export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.31-1428.14",
  commitId: "9f650e4c110bf791e65708b330f065563a59e180",
  commitTime: "2026-07-31T14:28:14.000Z",
});
